module.exports = __webpack_public_path__ + "img/prod-oven.fa757a5f.jpg";